import { to_currency } from "helpers/number"

const displayOptionPrice = (state, pref) => {
  if (pref == "ef" || pref == "ef2") {
    const choiceData = state.choices.e0
    if (
      typeof choiceData === "undefined" ||
      choiceData.value === null ||
      choiceData.is_default
    ) {
      return ""
    } else if (choiceData.value.length > 0 && choiceData.price > 0) {
      return to_currency(choiceData.price)
    } else {
      return ""
    }
  } else if (pref == "diamond") {
    let price = ""
    const showPrice =
      state.diamondUI.steps[state.diamondUI.currentStep] == "final_diamond"
    if (showPrice) {
      const stoneData = state.diamondSelector.selected_diamond
      if (stoneData?.price > 0) {
        price = to_currency(stoneData.price)
      }
    }
    return price
  } else {
    const wizardData = state.wizard.data[pref]
    if (wizardData?.valid_choice_keys?.length > 1) {
      // e.g., ONLR1017-15RD-R3 - o1 wizard contains all the o1, o2, o3 options
      // we need to show price by adding the selected values
      const validChoiceKeys = wizardData.valid_choice_keys
      const price = validChoiceKeys
        .map((key) => {
          const choiceData = state.choices[key]
          if (
            choiceData &&
            (choiceData.display_price || choiceData.price) > 0
          ) {
            return choiceData.display_price || choiceData.price
          } else {
            return 0
          }
        })
        .reduce((sum, a) => sum + a, 0)
      return price > 0 ? to_currency(price) : ""
    } else {
      const choiceData = state.choices[pref]
      if (typeof choiceData === "undefined") {
        return ""
      } else if ((choiceData.display_price || choiceData.price) > 0) {
        let price = choiceData.display_price || choiceData.price
        return to_currency(price)
      } else {
        return ""
      }
    }
  }
}

export default displayOptionPrice
